// tslint:disable

import * as React from 'react';
const ReactPaginate: any = require('react-paginate').default;

export class Pagination extends React.Component<any> {

    public state: any = {
        total: 0,
        page: 1,
        limit: 50
    };

    componentWillMount() {
        this.props.config.onPaginate$.subscribe((e: any) => {
            if (e.source === 'loader') {
                this.setState({
                    page: e.page,
                    limit: e.limit,
                    total: e.total
                });
            }

            if (e.source === 'pagination') {
                this.setState({
                    limit: e.limit
                });
            }
        });
    }

    public onPaginationChange(e: any) {
        this.props.config.onPaginate$.next({
            source: 'pagination',
            page: e.selected + 1
        });
    }

    private onLimitChange(e: any) {
        this.props.config.onPaginate$.next({
            source: 'pagination',
            limit: e.target.value
        });

        this.setState({
            page: e.page,
            limit: e.limit,
            total: e.total
        });
    }

    render() {
        return <div className="flex form-group">
            <ReactPaginate
                onPageChange={(e: any) => this.onPaginationChange(e)}
                containerClassName={'pagination'}
                pageCount={Math.ceil(this.state.total / this.state.limit)}
                forcePage={this.state.page - 1}
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                activeClassName={'active'}
            />

            <select className="form-control paginator-pagesize" value={this.state.limit}
                    onChange={(e) => this.onLimitChange(e)}>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
            </select>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/pagination.tsx